import { __awaiter, __generator } from "tslib";
import React from 'react';
import { Tooltip, Button, Loader, Box } from 'wix-style-react';
import { biLogger } from '../../../../bi';
import { config } from '../../../../config';
import { composer } from '../../../../component-decorators/composer';
import { getPathForBi, getReferralInfo, getWidgetReferral, } from '../../../../common/bi-events';
import { MarketPermissions, Path } from '../../../..';
import { openOrAddApp, getInstalledApps, isBundleAppAndNotInstalled, convertOriginToOriginMI, isBundleAppWithVoucher, } from '../../../../common/utils';
import { Origin } from '../../../../enums/marketplace-enums';
import { useConfigContext } from '../../../../config-context';
import { shouldShowAddAgain } from '@wix/manage-installed-apps';
import { getPermittedActions } from '../../../../api/api';
export var AddToSite = composer()
    .withMarketplaceStore()
    .withTranslation()
    .compose(function (_a) {
    var _b;
    var addToSiteData = _a.addToSiteData, t = _a.t, marketplaceStore = _a.marketplaceStore, size = _a.size, location = _a.location;
    var isAppInstalled = !!(marketplaceStore.installedApps &&
        marketplaceStore.installedApps.findIndex(function (installedApp) { return installedApp.webSolutionBase.id === addToSiteData.id; }) > -1);
    var isAddAgainApp = isAppInstalled &&
        shouldShowAddAgain((_b = marketplaceStore.installedApps) === null || _b === void 0 ? void 0 : _b.find(function (app) { return app.webSolutionBase.id === addToSiteData.id; }), convertOriginToOriginMI(config.origin));
    var btnText = getButtonText(isAppInstalled, !!isAddAgainApp, t, addToSiteData.id, marketplaceStore.bundleApps);
    // tslint:disable-next-line:react-hooks-nesting
    var _c = React.useState(true), isLoading = _c[0], setIsLoading = _c[1];
    React.useEffect(function () {
        var _a;
        if (marketplaceStore.metaSiteId &&
            !((_a = marketplaceStore === null || marketplaceStore === void 0 ? void 0 : marketplaceStore.permissions) === null || _a === void 0 ? void 0 : _a.length)) {
            // tslint:disable-next-line: no-floating-promises
            getPermittedActions(marketplaceStore.metaSiteId).then(function (value) {
                marketplaceStore.setPermissions(value);
                setIsLoading(false);
            });
        }
        else {
            setIsLoading(false);
        }
    }, [marketplaceStore.permissions]);
    var permitted = isPermitted(isAppInstalled, marketplaceStore.permissions);
    if (isLoading) {
        return (React.createElement(Box, { align: "center" },
            React.createElement(Loader, { size: 'tiny' })));
    }
    return (React.createElement(AddToSiteBtn, { addToSiteData: addToSiteData, text: btnText, isPermitted: permitted, size: size, location: location }));
});
export var AddToSiteBtn = composer()
    .withMarketplaceStore()
    .withTranslation()
    .compose(function (_a) {
    var addToSiteData = _a.addToSiteData, t = _a.t, marketplaceStore = _a.marketplaceStore, size = _a.size, isPermitted = _a.isPermitted, text = _a.text, location = _a.location;
    var configContext = useConfigContext();
    var updateInstalledApps = function () { return __awaiter(void 0, void 0, void 0, function () {
        var signedInstance, installedApps;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    signedInstance = configContext.getAppInstance('22bef345-3c5b-4c18-b782-74d4085112ff');
                    return [4 /*yield*/, getInstalledApps(signedInstance)];
                case 1:
                    installedApps = _a.sent();
                    marketplaceStore.setInstalledApps(installedApps);
                    return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(Tooltip, { disabled: isPermitted, content: t('marketplace.actions.tooltip') },
        React.createElement("span", null,
            React.createElement(Button, { dataHook: "btn-install-cta", onClick: function () {
                    return onAddToSiteClick(addToSiteData, configContext, updateInstalledApps, location);
                }, size: size, disabled: !isPermitted }, text))));
});
var getButtonText = function (isAppInstalled, isAddAgainApp, t, appID, bundleApps) {
    if (isBundleAppWithVoucher(appID, bundleApps) &&
        isBundleAppAndNotInstalled(appID, bundleApps)) {
        return t('solution.page.voucher');
    }
    if (isBundleAppAndNotInstalled(appID, bundleApps)) {
        return t('solution.page.claim');
    }
    if (isAppInstalled && isAddAgainApp) {
        return t('solution.page.addAgain');
    }
    if (isAppInstalled) {
        return t('solution.page.open');
    }
    return t('solution.page.addToSite');
};
function sendAddToSiteBi(biData, location, route, solutionBiParams) {
    biLogger.addAppClick({
        app_id: biData.devNameClickData.app_id,
        category: biData.category,
        pageType: 'solution_page',
        click_location: location,
        slug_id: route === null || route === void 0 ? void 0 : route.referralSectionName,
        market: solutionBiParams.market,
        tag_type: solutionBiParams.tagType,
        tag_name: solutionBiParams.tagName,
        referral_info: solutionBiParams.referralInfo,
        search_term: solutionBiParams.searchTerm,
        widget_referral: solutionBiParams.widgetReferral,
        collimp_id: solutionBiParams.collimp_id,
        referral_section_name: solutionBiParams.referralSectionName,
        section: solutionBiParams.section,
    });
}
export var onAddToSiteClick = function (props, configContext, updateInstalledApps, location) {
    var appForInstallation = {
        id: props.id,
        pricing: props.pricing,
        openConsentIn: props.openConsentIn,
        name: props.name,
        teaser: props.teaser,
        icon: props.icon,
        description: props.description,
        company: props.company,
        Tags: props.Tags,
    };
    var _a = props.marketplaceStore, route = _a.route, prevRoute = _a.prevRoute;
    var solutionBiParams = {
        market: config.originForBI,
        tagType: getPathForBi(Path.WEB_SOLUTION),
        tagName: props.biData.devNameClickData.app_id,
        referralInfo: getReferralInfo(route === null || route === void 0 ? void 0 : route.referral, prevRoute),
        searchTerm: (route === null || route === void 0 ? void 0 : route.query) || (prevRoute === null || prevRoute === void 0 ? void 0 : prevRoute.query),
        widgetReferral: getWidgetReferral(),
        collimp_id: route === null || route === void 0 ? void 0 : route.collimp_id,
        referralSectionName: (route === null || route === void 0 ? void 0 : route.referralSectionName) || (route === null || route === void 0 ? void 0 : route.referral),
        section: (route === null || route === void 0 ? void 0 : route.section) || null,
    };
    sendAddToSiteBi(props.biData, location, route, solutionBiParams);
    openOrAddApp(appForInstallation, props.marketplaceStore, solutionBiParams, configContext, props.experiments, updateInstalledApps);
};
var isPermitted = function (isAppInstalled, permissions) {
    if (config.origin === Origin.STANDALONE) {
        return true;
    }
    return (isAppInstalled || (permissions === null || permissions === void 0 ? void 0 : permissions.some(function (p) { return p === MarketPermissions.INSTALL_APP; })));
};
//# sourceMappingURL=add-to-site.js.map